import { Button, Col, Form, Input, Row, Table, message } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { DatePicker as DatePickerJalali, JalaliLocaleListener } from "antd-jalali";
import { Excel } from "antd-table-saveas-excel";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDealer } from "../../../../tools/api";
import { convertToGregorian, convertToJalaliWithoutTime } from "../../../../tools/tools";
import { NotFound } from "../../../../sources/svg/svg";
import Loading from "../../../auxiliary/loader/loading";

const KIT_COLUMNS = [
	{ title: "شماره کیت", dataIndex: "kitNo", key: "kitNo", width: 150 },
	{ title: "نوع مخزن", dataIndex: "poolType", key: "poolType", width: 180 },
	{ title: "وضعیت", dataIndex: "requestStatus", key: "requestStatus", width: 150 },
];

const CompletedRequests = () => {
	const [frmSearch] = Form.useForm();
	const [messageApi, contextHolder] = message.useMessage();

	const { queryRegisterKitRequestDistributer, queryKitAssignedToUser } = useDealer();
	const { _currentUser } = useSelector((state) => state?.another);

	const [tableData, setTableData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [downloadingId, setDownloadingId] = useState(null);

	// state current page show Records
	const [currentPage, setCurrentPage] = useState(0);
	// state totalRecord
	const [totalRecord, setTotalRecord] = useState(0);

	const handleSearch = async () => {
		setIsLoading(true);
		try {
			const values = frmSearch.getFieldsValue();

			const payload = {
				searchConfigModel: {
					sort: "",
					filter: values?.username || "",
					entriesPerPage: 10,
					page: currentPage === 0 ? 0 : currentPage - 1,
					totalRowCount: 0,
				},
				userName: values?.username || "",
				requestStatus: 3,
			};

			if (values?.fromdate) {
				payload.fromAssignedDate = convertToGregorian(values.fromdate.format("YYYY-MM-DD"), "-", "-");
			}

			if (values?.todate) {
				payload.toAssignedDate = convertToGregorian(values.todate.format("YYYY-MM-DD"), "-", "-");
			}

			const response = await queryRegisterKitRequestDistributer(payload);

			if (response) {
				const result = response?.Result || [];
				if (values?.username && result.length === 0) {
					messageApi.open({ type: "error", content: "نام کاربری وارد شده صحیح نیست." });
				}
				setTableData(result);
				setTotalRecord(response?.searchconfigmodel?.totalrowcount || 0);
			}
		} catch (error) {
			console.error("Failed to load completed kit requests:", error);
		}
		setIsLoading(false);
	};

	useEffect(() => {
		handleSearch();
	}, [currentPage]);

	// دریافت لیست کیت‌های تخصیص‌یافته‌ی یه درخواست و خروجی اکسل (با ساپورت فارسی)
	const handleDownload = async (requestId) => {
		if (!requestId) return;
		setDownloadingId(requestId);
		try {
			const kits = (await queryKitAssignedToUser({ iccidRequestId: requestId })) || [];
			if (kits.length > 0) {
				const excel = new Excel();
				excel
					.addSheet("کیت‌های تخصیص‌یافته")
					.addColumns(KIT_COLUMNS)
					.addDataSource(
						kits.map((item, key) => ({
							key,
							kitNo: item.kitNo,
							poolType: item.poolType,
							requestStatus: item.requestStatus,
						})),
						{ str2Percent: true },
					)
					.saveAs("assign-kit-completed-request.xlsx");
			} else {
				messageApi.open({ type: "error", content: "کیتی برای این درخواست یافت نشد." });
			}
		} catch (error) {
			console.error("Failed to download assigned kits:", error);
			messageApi.open({ type: "error", content: "خروجی اکسل ساخته نشد. دوباره تلاش کنید." });
		}
		setDownloadingId(null);
	};

	const columns = [
		{
			title: "تاریخ تخصیص",
			dataIndex: "assignDate",
			key: "assignDate",
			width: 150,
			sorter: (a, b) => new Date(a.rawAssignDate || 0) - new Date(b.rawAssignDate || 0),
		},
		{
			title: "تعداد کیت",
			dataIndex: "requestedQuantity",
			key: "requestedQuantity",
			width: 110,
		},
		{
			title: "نام کاربری نماینده",
			dataIndex: "userName",
			key: "userName",
			width: 150,
		},
		{
			title: "نوع مخزن",
			dataIndex: "poolType",
			key: "poolType",
			width: 180,
		},
		{
			title: "آدرس",
			dataIndex: "address",
			key: "address",
			width: 200,
		},
		{
			title: "تلفن",
			dataIndex: "telNoOne",
			key: "telNoOne",
			width: 150,
		},
		{
			title: "عملیات",
			dataIndex: "action",
			key: "action",
			width: 120,
		},
	];

	const dataSource = tableData.map((item, key) => ({
		key,
		rawAssignDate: item.assignDate,
		assignDate: convertToJalaliWithoutTime(item.assignDate),
		requestedQuantity: item.requestedQuantity,
		userName: item.userName,
		poolType: item.poolType,
		address: item.address,
		telNoOne: <span dir="ltr">{item.telNoOne}</span>,
		action: (
			<Button className="btn-normal" loading={downloadingId === item.requsetId} onClick={() => handleDownload(item.requsetId)}>
				دانلود
			</Button>
		),
	}));

	return (
		<>
			{contextHolder}
			<div className="holder-form-filter">
				<Form form={frmSearch} layout="vertical" onFinish={handleSearch}>
					<Row gutter={16} align="bottom">
						<Col>
							<JalaliLocaleListener />
							<Form.Item className="input-normal" name="fromdate" label="از تاریخ">
								<DatePickerJalali format="YYYY/MM/DD" placeholder="از تاریخ" />
							</Form.Item>
						</Col>
						<Col>
							<Form.Item className="input-normal" name="todate" label="تا تاریخ">
								<DatePickerJalali format="YYYY/MM/DD" placeholder="تا تاریخ" />
							</Form.Item>
						</Col>
						<Col>
							<Form.Item className="input-normal" name="username" label="نام کاربری نماینده">
								<Input placeholder="نام کاربری نماینده" allowClear dir="ltr" />
							</Form.Item>
						</Col>
						<Col>
							<Form.Item label="&nbsp;">
								<Button htmlType="submit" className="btn-normal btn-aptel" icon={<SearchOutlined />} />
							</Form.Item>
						</Col>
					</Row>
				</Form>
			</div>

			<div className="holder-table">
				<Table
					className="tbl-normal"
					columns={columns}
					locale={{
						emptyText: <NotFound text={"رکوردی یافت نشد."} />,
					}}
					pagination={{
						className: "page-pagination",
						onChange: (page) => {
							setCurrentPage(page);
						},
						pageSize: 10,
						align: "start",
						current: currentPage === 0 ? 1 : currentPage,
						total: totalRecord,
						showSizeChanger: false,
					}}
					scroll={{ y: "100%" }}
					dataSource={dataSource}
				/>
			</div>

			<Loading isOpen={isLoading} />
		</>
	);
};

export default CompletedRequests;
